import { CSSModule } from '../cssModules.ts';

export interface TransitionMapping {
  /**
   * ClassName to apply while the element has started entering
   */
  enter: string;
  /**
   * ClassName to apply while the element is entering
   */
  enterActive: string;
  /**
   * ClassName to apply while the element is done entering
   */
  enterDone: string;
  /**
   * ClassName to apply while the element has started exiting
   */
  exit: string;
  /**
   * ClassName to apply while the element is exiting
   */
  exitActive: string;
  /**
   * ClassName to apply while the element is done exiting
   */
  exitDone: string;
  /**
   * ClassName to apply while the element has just appeared
   * http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear
   */
  appear: string;
  /**
   * ClassName to apply while the element is appearing
   */
  appearActive: string;
  /**
   * ClassName to apply while the element is done appearing
   */
  appearDone: string;
}

/**
 * Converts a base className and a CSS module to transition className mapping
 * @param {string} baseClassName
 * @param {CSSModule} styleMapping
 * @returns {TransitionMapping} transition className mapping
 */
export default function transitionVariants(
  className: string,
  styleMap: CSSModule
): TransitionMapping {
  return {
    appear: styleMap[`${className}--appear`],
    appearActive: styleMap[`${className}--appear-active`],
    appearDone: styleMap[`${className}--appear-done`],
    enter: styleMap[`${className}--enter`],
    enterActive: styleMap[`${className}--enter-active`],
    enterDone: styleMap[`${className}--enter-done`],
    exit: styleMap[`${className}--exit`],
    exitActive: styleMap[`${className}--exit-active`],
    exitDone: styleMap[`${className}--exit-done`]
  };
}
